import { SymbolWinData } from "@lib/titan2-slingo/dist/api/model/data/SymbolWinData";
import { ApiConstants } from "../enum/ApiConstants";
export class CollectWinResultData extends SymbolWinData {
    solidify() {
        this.scatterWin = this.data?.getNumber(ApiConstants.PROPERTY_SCATTER_WIN) ?? 0;
        this.lineWin = this.data?.getNumber(ApiConstants.PROPERTY_WINLINE_WIN) ?? 0;
    }
    getScatterWin() {
        return this.scatterWin;
    }
    getWinLineWin() {
        return this.lineWin;
    }
}
//# sourceMappingURL=CollectWinResultData.js.map